exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__Highlighter__mark {\n  background-color: #d4e3ac;\n  border-radius: 4px;\n}\n", ""]);

// exports
exports.locals = {
	"mark": "DS__Highlighter__mark"
};